import { createRoot } from 'react-dom/client';
import './index.css';
import '@gaiads/telia-react-component-library/build/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';

import './i18n';
import store from './store/configureStore';
import history from './history';
import VersionInfo from './VersionInfo';

const VERSION_INFO_URL = '/version/info';
const container = document.getElementById('root');
const root = createRoot(container!);
if (window.location.pathname === VERSION_INFO_URL) {
  root.render(<VersionInfo />);
} else {
  root.render(
    /*
    Using React.StrictMode with React v18.x.x in development results to "whenever a component mounts in development, React will simulate
    immediately unmounting and remounting the component" - https://reactjs.org/docs/strict-mode.html#ensuring-reusable-state
    -> this makes all useEffects run at least twice and that seems to break login functionality somehow (might break something else as well).
    React.StrictMode commented out until login functionality can be made to work with it.

    More info about React.StrictMode changes in React v18.x.x at
    - https://reactjs.org/docs/strict-mode.html#ensuring-reusable-state
    - https://github.com/facebook/react/blob/main/CHANGELOG.md#react-1 (under "Stricter Strict Mode")
    */
    // <React.StrictMode>
    <Router history={history}>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>,
    // </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
